function decodeBase64Url(value) {
  const base64 = value.replace(/-/g, '+').replace(/_/g, '/');
  const padded = base64.padEnd(base64.length + ((4 - (base64.length % 4)) % 4), '=');
  return atob(padded);
}

export function decodeJwtPayload(token) {
  if (!token || typeof token !== 'string') return {};

  const [, payload] = token.split('.');
  if (!payload) return {};

  try {
    return JSON.parse(decodeBase64Url(payload));
  } catch (error) {
    return {};
  }
}

function getClaimLeafName(key) {
  return String(key || '')
    .split(/[/:.]/)
    .filter(Boolean)
    .pop()
    ?.toLowerCase() || '';
}

function getSupportedClaimType(key, trustScopeClaims = false) {
  const leafName = getClaimLeafName(key);
  if (leafName === 'permissions' || leafName === 'permission') return 'permission';
  if (leafName === 'roles' || leafName === 'role') return 'role';
  if (trustScopeClaims && (leafName === 'scope' || leafName === 'scp')) return 'scope';
  return '';
}

function addClaimValues(target, value) {
  if (!value) return;

  if (Array.isArray(value)) {
    value.forEach((item) => addClaimValues(target, item));
    return;
  }

  if (typeof value !== 'string') return;

  const trimmed = value.trim();
  if (!trimmed) return;

  target.add(trimmed);
  trimmed.split(/\s+/).forEach((item) => {
    if (item) target.add(item);
  });
  trimmed.split(',').forEach((item) => {
    const normalized = item.trim();
    if (normalized) target.add(normalized);
  });
}

export function getPermissionsFromClaims(claims = {}, options = {}) {
  const collected = new Set();
  const trustScopeClaims = Boolean(options.trustScopeClaims);

  Object.entries(claims || {}).forEach(([key, value]) => {
    if (getSupportedClaimType(key, trustScopeClaims)) {
      addClaimValues(collected, value);
    }
  });

  const permissions = options.permissions || {};
  const hasAny = (values = []) => values.some((value) => collected.has(value));

  if (permissions.user && hasAny(options.userRoleAliases)) {
    collected.add(permissions.user);
  }
  if (permissions.admin && hasAny(options.adminRoleAliases)) {
    collected.add(permissions.admin);
  }

  return [...collected].filter(Boolean);
}
